import EventEmitter from "events";

class StationSwitchProps extends EventEmitter {
  _switcherProps = {};

  get switcherProps() {
    return this._switcherProps;
  }

  setProps(props = {}) {
    this._switcherProps = { ...this._switcherProps, ...props };
    this.emit("switcher-props-update", { switcherProps: this._switcherProps });
  }

  resetProps() {
    this._switcherProps = {};
  }
}

const stationSwitchProps = new StationSwitchProps();
export { stationSwitchProps };
